module.exports = __webpack_public_path__ + "static/lightTextureBackground-802efa6bb100297460deafd0a2d1a422.svg";